
import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import AddToListForm from '../list-form';
import { useRecoilState } from 'recoil';
import { pinnedSelectionState } from '../../recoils/usePinnedSelection/isPinnedSelectionAtom';

interface IProp {
  numberOfSelected: number;
  gridApi: any;
  currentUrlToRedirect: string;
  isReverse: boolean;
}

export const AddToList: React.FC<IProp> = ({
  numberOfSelected,
  gridApi,
  currentUrlToRedirect,
  isReverse
}) => {

  const { t } = useTranslation();

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedDataState, setSelectedDataState] = useState<any>();
  const [pinnedSelected] = useRecoilState(pinnedSelectionState);

  const toggleForm = () => setIsFormOpen(!isFormOpen);

  const addToListHandler = (e: any) => {
    e.preventDefault();

    if (gridApi && !gridApi.destroyCalled) {
      // ! Get selected data when
      let selectedNodes = gridApi.getSelectedNodes();
      if(pinnedSelected){
        const pinnedNode = gridApi.getPinnedTopRow(0);
        selectedNodes = [...selectedNodes, pinnedNode]
      }

      const selectedData = selectedNodes.map((node: any) => node.data);

      setSelectedDataState(selectedData);
    }

    toggleForm();
  }

  return (
    <div>
      <button
        className="dk-btn__primary"
        onClick={addToListHandler}
        id="add-to-list-button"
        data-testid="addToListBtn"
      >
        {t('xref-add')}{' '}
        {numberOfSelected} {(numberOfSelected > 1|| (numberOfSelected > 0 && pinnedSelected)) ? t('xref-products') : t('xref-product')} {' '}
        {t('xref-to-list')}
      </button>

      <AddToListForm
        isFormOpen={isFormOpen}
        setIsFormOpen={setIsFormOpen}
        selectedData={selectedDataState}
        currentUrlToRedirect={currentUrlToRedirect}
        isReverse={isReverse}
      ></AddToListForm>

    </div>
  )
}
